import { AxiosError, AxiosResponse } from 'axios'
import {
  IAuthenticateErrorBody,
  IMfaChallengeResponse,
  IUserAuthenticatedRequest,
  IUserAuthenticatedResponse,
  TAuthenticateStepResult
} from 'dtos/User'
import api from 'services/api'

export const authenticate = async (params: IUserAuthenticatedRequest): Promise<IUserAuthenticatedResponse> => {
  const result: AxiosResponse<IUserAuthenticatedResponse> = await api.post('/auth/portal/login', params)

  return result.data
}

// Nota 3 (portal-cannect-2fa) §1 — POST /auth/portal/login (nota http-only:
// é a rota que emite refresh token/cookie httpOnly via sendAuthResult;
// /authenticate legado usa withRefresh:false e nunca seta cookie). Nunca
// lança para os 4 ramos documentados (a/b/c/d): resolve sempre num
// TAuthenticateStepResult tipado. CA6: "Senha Inválida" e "Usuario não
// encontrado" (dois erros 400 sem `code`, hoje indistinguíveis por design)
// caem deliberadamente no MESMO kind ('invalid_credentials') — nenhum
// chamador consegue diferenciar e-mail inexistente de senha errada.
export const authenticateWithChallenge = async (
  params: IUserAuthenticatedRequest
): Promise<TAuthenticateStepResult> => {
  try {
    const result: AxiosResponse<IUserAuthenticatedResponse | IMfaChallengeResponse> = await api.post(
      '/auth/portal/login',
      params
    )
    const { data } = result

    if ('mfa_required' in data && data.mfa_required) {
      return { kind: 'challenge', data }
    }

    return { kind: 'authenticated', data: data as IUserAuthenticatedResponse }
  } catch (error) {
    const axiosError = error as AxiosError<IAuthenticateErrorBody>
    const body = axiosError.response?.data
    const status = axiosError.response?.status

    if (status === 403 && body?.code === 'MFA_ENROLLMENT_REQUIRED' && body.token) {
      return { kind: 'enrollment_required', token: body.token }
    }

    if (status === 400 && body?.code === 'METHOD_REQUIRED' && body.methods) {
      return { kind: 'method_required', methods: body.methods.map((method) => method.type) }
    }

    if (status === 400 && !body?.code) {
      return { kind: 'invalid_credentials' }
    }

    throw error
  }
}
